var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148612",
    "data-name": "Rectangle 148612",
    width: 24,
    height: 24,
    transform: "translate(295 628)",
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-295 -628)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-button",
    transform: "translate(151.776 608.917) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_54",
    "data-name": "Union 54",
    d: "M20581.629,17818.852a1.008,1.008,0,1,1,0-2.016h4.082a1.786,1.786,0,0,0,1.783-1.783v-3.291a1.789,1.789,0,0,0-1.783-1.789h-4.082a1,1,0,1,1,0-2.01h4.082a3.8,3.8,0,0,1,3.8,3.8v3.291a3.8,3.8,0,0,1-3.8,3.8Zm-10.437-.006a3.805,3.805,0,0,1-3.8-3.8v-3.281a3.8,3.8,0,0,1,3.8-3.8h4.082a1,1,0,1,1,0,2.01h-4.082a1.789,1.789,0,0,0-1.783,1.789v3.281a1.787,1.787,0,0,0,1.783,1.787h4.082a1.008,1.008,0,0,1,0,2.016Zm3.172-4.309a1.008,1.008,0,0,1,0-2.016h8.164a1.008,1.008,0,0,1,1.008,1,1.028,1.028,0,0,1-1.008,1.014Z",
    transform: "translate(-20490.668 -17681.668)",
    fill: "#ff411a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ce260744.svg";
export { ForwardRef as ReactComponent };